var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_177161",
    "data-name": "Group 177161",
    xmlns: "http://www.w3.org/2000/svg",
    width: 247,
    height: 126,
    viewBox: "0 0 247 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_145480",
    "data-name": "Rectangle 145480",
    fill: "#fff7ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0H241a6,6,0,0,1,6,6V126a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V6A6,6,0,0,1,6,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,.5H241A5.5,5.5,0,0,1,246.5,6V125.5a0,0,0,0,1,0,0H.5a0,0,0,0,1,0,0V6A5.5,5.5,0,0,1,6,.5Z",
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "table-list-alt-svgrepo-com",
    d: "M4,11.891H27.65M4,19.281H27.65M11.391,4.5V26.672m-2.661,0H22.92a7.344,7.344,0,0,0,3.116-.322,2.956,2.956,0,0,0,1.292-1.292,7.344,7.344,0,0,0,.322-3.116V9.23a7.344,7.344,0,0,0-.322-3.116,2.956,2.956,0,0,0-1.292-1.292A7.344,7.344,0,0,0,22.92,4.5H8.73a7.344,7.344,0,0,0-3.116.322A2.956,2.956,0,0,0,4.322,6.114,7.344,7.344,0,0,0,4,9.23V21.942a7.344,7.344,0,0,0,.322,3.116A2.956,2.956,0,0,0,5.614,26.35,7.344,7.344,0,0,0,8.73,26.672Z",
    transform: "translate(107.5 47)",
    fill: "none",
    stroke: "#ffb666",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoThumbnail);
export default __webpack_public_path__ + "static/media/noThumbnail.e4a10e9562ba3e2449b91411a921ffec.svg";
export { ForwardRef as ReactComponent };